import _ from 'lodash';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ForwarderService, Region, Speciality, CorpInfo } from '../../../services/index'
declare var $:any;

@Component({
  selector: 'ocean-line-service-route',
  templateUrl: 'ocean-line-service-route.html'
})
export class OceanLineServiceRouteComponent {

  @Output() hideEe: EventEmitter<any> = new EventEmitter();
  
  _corpId:number;
  @Input() set corpId(corpId){
    if(!corpId) return;
    this._corpId = corpId;
  }

  get corpId(){
    return this._corpId;
  }

  @Input() selectedRoute: string[] = [];


  routes: string[] = ['중국', '남미주', '북미주', '중남미', '동남아', '서남아', '인도', '일본', '홍콩', '서유럽', '북유럽', '러시아', '호주', '중동', '중앙아시아', '몽골', '괌', '북아프리카', '서아프리카', '캐나다', '지중해'];
  

  constructor(
    private forwarderService:ForwarderService
  ) {
    
  }

  ngOnInit() {
    this.forwarderService.getOceanLineServiceRoutes(this.corpId).subscribe( resp => {
      this.selectedRoute = [];
      if (resp && resp.routes) {
        this.selectedRoute.push(...resp.routes);
      }

      for (let sr of this.selectedRoute) {
        let i = _.findIndex(this.routes, r => r == sr);
        
        if (i >= 0) {
          document.getElementById('route_' + i).setAttribute('checked', 'checked');
        }
      }
    });
  }

  
  postOceanLineServiceRoute(){
    this.forwarderService.postOceanLineServiceRoutes(this.corpId, this.selectedRoute).subscribe( resp => {
      $.sweetModal({
        content: '저장되었습니다.',
        icon: $.sweetModal.ICON_SUCCESS,
      });
      this.close();      
      
    }, err => {
        $.sweetModal({
          content: err,
          icon: $.sweetModal.ICON_WARNING
        });
      
    });
  }

  close(){
    this.hideEe.emit();
  }


  onChangeRoute(route, checked) {
    if (checked) {
      this.selectedRoute.push(route);
    } else {
      let index = _.findIndex(this.selectedRoute, r => r == route);
      this.selectedRoute.splice(index, 1);
    }
  }

  isCheckedRoute(route) {
    return _.findIndex(this.selectedRoute, r => r == route) >= 0;
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/fwdr/detail/ocean-line-service-route.ts